import React, { lazy, Suspense } from 'react'
import { Provider } from 'react-redux'
import { persistor, store } from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import ErrorBoundary from './components/ErrorBoundary'
const AppRouter = lazy(() => import("./routes"))
const App = () => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Suspense fallback={<div className="splash_screen">
          </div>}>
            <AppRouter />
          </Suspense>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  )
}

export default App
